const API_ROUTES = {
  CRYPTO_DASHBOARD: 'bo/crypto-dashboard/marketplaces',
  MARKET_TYPES: 'market-types',
  MARKET_TYPES_TOURNAMENT_GROUPS_ELIGIBLE: 'market-types/groups-eligible',
  MARKET_TYPE_GROUPS: 'market-type-groups',
  MARKET_TYPE_GROUP_CATEGORIES: 'market-type-group-categories',

  MARKET_COUNT: 'markets/count',

  FTB_SPECIAL_VALUES_REOFFER: 'outcomes/reoffer',
  OM_SPECIAL_VALUES_REOFFER: 'special-values',

  REPORTS: {
    DAILY: 'reports/daily',
    PARTNERS: {
      MANAGERS: 'reports/partners/managers',
      AGENTS: 'reports/partners/agents',
      AFFILIATES: 'reports/partners/affiliates',
    },
    PLAYERS: 'reports/players',
    BONUSES: 'reports/bonuses',
    WELCOME_BONUS: 'welcome-bonus/reports',
    JACKPOTS: 'reports/jackpots',
    PAYMENTS: {
      TOTAL: 'reports/payments/total',
      LIST: 'reports/payments/list',
    },
    AFFILIATE_CAMPAIGN: 'campaign/reports',
  },

  CAMPAIGNS: 'campaign',
  CAMPAIGN_BONUS: 'campaign-bonus',
  CAMPAIGN_BONUS_GLOBAL: 'campaign-bonus/global',
  WELCOME_BONUS_AFFILIATE_OPTIONS: 'welcome-bonus/affiliate-options',
  BONUS_CAMPAIGNS: 'bonus-campaigns',
  CASHBACK_BONUS_CAMPAIGNS: 'cashback-bonus-campaigns',
  WELCOME_BONUS: 'welcome-bonus',
  BONUS_MARKET_TYPE_EXCLUSIONS: 'bonus/market-type-exclusions',
  // Provisional until the sportsbook-feed-api selector route is finalized.
  BONUS_MARKET_TYPE_EXCLUSION_SELECTORS: 'bonus/market-type-exclusion-selectors',
  WAGERING_CONFIGS: 'wagering-configs',

  PAYMENT_REQUESTS: 'payment-requests',
  PAYMENT_LIMIT_CONFIGURATIONS: 'payment-limit-configurations',

  MARKETPLACE: 'bo/marketplace',
  MARKETPLACE_CONFIG: 'bo/marketplace/config',
  BO_TEMPLATES_ACTIVE: 'bo/templates/active',
  BO_TEMPLATES_SWITCH: 'bo/templates/switch',
  BO_TEMPLATES_REQUEST_SNAPSHOT: 'bo/templates/request-snapshot',
  AGENT_SEARCH: 'agent/search',
  CRM: {
    AGENT_BY_ID: 'agent/by-id',
    AGENT_COMMISSION: 'agent/commission',
  },
  SUPER_ADMIN_ACCOUNTS: 'super-admin/accounts',
  SUPER_ADMIN_FLAGS: 'super-admin/flags',
  SUPER_ADMIN_PROVIDER_STATUSES: 'super-admin/provider-statuses',
  SUPER_ADMIN_DATABASE_ACTIVE_QUERIES: 'super-admin/database-active-queries',
  SUPER_ADMIN_TERMINATE_DATABASE_QUERIES: 'super-admin/database-active-queries/terminate',
  SUPER_ADMIN_RESOLVE_OPEN_BETTING_SLIPS: 'super-admin/actions/resolve-open-betting-slips',

  CASINO: {
    GAMES: 'games',
    GAME_UPDATE: 'game',
    PROVIDERS: 'provider/providers',
    ACTIVE_AGGREGATOR_PROVIDERS: 'provider/active-aggregator-providers',
    PROVIDER_UPDATE: 'provider/edit',
    CATEGORIES: 'category/categories',
    CATEGORY_CREATE: 'category/create',
    CATEGORY_UPDATE: 'category/patch',
    AUTHENTICATE: 'auth/authenticate',
    MARKETPLACE_UPDATE: 'marketplace/update',
    MARKETPLACE_ACTIVE_PROVIDERS: 'marketplace/active-providers',
    CURRENCIES: 'currencies',
    USERS: 'user/users',
    GOLD_GAMES_CAMPAIGNS: 'gold-games/campaigns',
    GGA_FREE_SPINS: 'gga/free-spins',
    GGA_FREE_SPIN_OPTIONS: 'gga/free-spins/options',
    GGA_FREE_SPINS_BATCH: 'gga/free-spins/batch',
    TRANSACTIONS: 'transaction/transactions',
    BETS: 'bet/bets',
    STATISTICS_REVENUE: 'statistics/revenue',
    STATISTICS_USERS: 'statistics/users',
    SUMMARY: 'transaction/summary',
    GGA_FREE_SPIN_BET_LEVELS: 'gga/free-spins/bet-levels',
  },
} as const;

export default API_ROUTES;
